import { QueryFactory } from "../../../../Common";
export const QGetLastBetAge = QueryFactory("GetLastBetAge");
//# sourceMappingURL=QGetLastBetAge.js.map